<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { PRODUT_MOA_MODULE } from '@/state/modules/productMoa'
import { lookupMethods, productMoaMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";

/**
 * Tabs & accordions component
 */
export default {
    page: {
        title: i18n.t("label.updateX", [i18n.t("module.productMoa")]),
    },
    components: { Layout, PageHeader, Multiselect },
    beforeRouteLeave(to, from, next) {
        if (to.name != "Product-moa-listing") {
            sessionHelper.clearSearch(SESSION.PRODUCT_MOA_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(PRODUT_MOA_MODULE, ["status"]),
        ...mapState(LOOKUP_MODULE),
        data() {
            return this.$store.state.productMoa.details;
        },
        productDdl() {
            return this.$store.state.lookup.productDdl;
        },
        moaDdl() {
            return this.$store.state.lookup.moaDdl;
        },
    },
    data() {
        return {
            title: i18n.t("label.updateX", [i18n.t("module.productMoa")]),
            items: [
                {
                    text: i18n.t('module.dashboard'),
                    href: "/",
                },
                {
                    text: i18n.t("module.productMoa"),
                    href: "/product-moa",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t('module.productMoa')]),
                    active: true,
                },
            ],
            submitted: false,
            permissions: sessionHelper.getPermissions(),
            updatePermission: null,
            readPermission: null,
            statusDdl: ddlHelper.getActivationStatus(true),
        };
    },
    validations: {
        data: {
            // name: { required },
            productID: { required },
            moaID: { required },
        },
    },
    async created() {
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_MOA_SEARCH);
        this.searchCriteriaProductSpecial = sessionHelper.retrieveSearch(SESSION.PRODUCT_SPECIAL_SEARCH);

        if (this.searchCriteriaProductSpecial != null && this.searchCriteriaProductSpecial != '') {
            this.isCloseWhenSuccess = this.searchCriteriaProductSpecial.isCloseWhenSuccess;
        }
        else {
            this.isCloseWhenSuccess = false;
        }

        await this.validPermissions();
        this.lookupProduct({ hasOptionAll: false });
        this.lookupMOA({ hasOptionAll: false });
        await this.getProductMoaData();
    },
    methods: {
        ...productMoaMethods,
        ...lookupMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PMOA_PMU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PMOA_PMR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }
        },

        async getProductMoaData() {
            this.isLoading = true;
            if (this.readPermission == true) {
                await this.getProductMoa({ id: this.searchCriteria.selectedRecordId });
            }
            this.isLoading = false;
        },

        async requestUpdate() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.data.$invalid) {
                console.log("Validation failed");

                for (const field in this.$v.data) {
                    if (this.$v.data[field].$invalid) {
                        console.log(`Validation failed for: ${field}`);
                    }
                }
                return;
            } else {
                let isCloseWhenSuccess = this.isCloseWhenSuccess;

                let data = {
                    id: this.data.uuid,
                    productID: this.data.productID.value,
                    moaID: this.data.moaID.value,
                };
                if (this.updatePermission == true) {
                    await this.updateProductMoa({ data, isCloseWhenSuccess });
                }
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <b-tabs pills justified content-class="p-3 text-muted">
                            <b-tab active class="border-0" @click="getProductMoaData">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="fas fa-home"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.productMoa') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <form @submit.prevent="requestUpdate" v-if="readPermission == true">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group id="productID" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.product')" label-for="productID">
                                                <multiselect v-model="data.productID"
                                                    deselect-label="Can't remove this value" track-by="value"
                                                    label="text" placeholder="Select one" :options="productDdl"
                                                    :searchable="true" :allow-empty="false">
                                                </multiselect>
                                                <div v-if="submitted && !$v.data.productID.required"
                                                    class="invalid-feedback" style="display: block;">
                                                    <span>{{ $t("message.requiredX", [$t("module.product")]) }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group id="moaID" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.moa')" label-for="moaID">
                                                <multiselect v-model="data.moaID"
                                                    deselect-label="Can't remove this value" track-by="value"
                                                    label="text" placeholder="Select one" :options="moaDdl"
                                                    :searchable="true" :allow-empty="false">
                                                </multiselect>
                                                <div v-if="submitted && !$v.data.moaID.required"
                                                    class="invalid-feedback" style="display: block;">
                                                    <span>{{ $t("message.requiredX", [$t("module.moa")]) }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>
                                    </div>

                                    <div class="mt-4 text-center" style="float: right">
                                        <button class="btn btn-primary w-md waves-effect waves-light"
                                            style="margin-right: 10px" type="submit"
                                            :disabled="status.update || updatePermission != true">
                                            {{ $t("label.updateX", [$t("module.productMoa")]) }}
                                        </button>
                                    </div>
                                </form>
                                <div style="text-align: center;" v-else>
                                    {{ $t('message.noPermissionMessage') }}
                                </div>
                            </b-tab>

                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>